import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

/**
 * Preview of the signing modal for the formats without an HTML version (all
 * but AUTOSUR): who signs and which assets the voucher covers. Rebuilding every
 * client format in HTML would duplicate it; the full document is the paper
 * download, which is the same PDF without signature.
 */
const VoucherSummary = ({ t, custodian, position, assets }) => (
  <div className="border rounded p-3 mb-3 small" style={{ background: '#fff' }}>
    <div className="mb-2">
      <span className="font-weight-bold">{t('custodyVoucher.custodian')}: </span>
      {custodian}
      {position ? ` — ${position}` : ''}
    </div>
    <div className="font-weight-bold mb-1">{t('custodyVoucher.assets')}</div>
    <table className="table table-sm mb-2">
      <thead>
        <tr>
          <th>{t('asset_employeePDF.table.number')}</th>
          <th>{t('asset_employeePDF.table.name')}</th>
          <th>{t('asset_employeePDF.table.serie')}</th>
        </tr>
      </thead>
      <tbody>
        {(assets || []).map((asset, index) => (
          <tr key={asset.id || index}>
            <td>{asset.number}</td>
            <td>{asset.name}</td>
            <td>{asset.serie}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div className="text-muted">{t('custodyVoucher.reviewHint')}</div>
  </div>
);

VoucherSummary.propTypes = {
  custodian: PropTypes.string,
  position: PropTypes.string,
  assets: PropTypes.array,
  t: PropTypes.func.isRequired,
};

export default translate()(VoucherSummary);



// WEBPACK FOOTER //
// src/modules/common/components/VoucherSummary.js